const styles = {
	global: {
		".date-wrapper": {
			
		},
	},
};

export default styles;
